import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from "react-intl";
import * as toast from "react-toastify";
import { Input, Label, FormGroup } from "reactstrap";
import { handleRequestError, Request } from '../../../helpers/request'
import clsx from 'clsx'

class NewsletterSubscription extends Component {
    state = {
        email: '',
    };

    submit = (e) => {
        const { intl } = this.props;
        e.preventDefault();
        this.setState({ loading: true });
        const { email } = this.state;
        Request.post('newsletter/submit', { email })
            .then(() => {
                toast.toast.success(
                    intl.formatMessage({
                        id: "portfolio.blog.newsletter.success",
                        defaultMessage: "Merci de votre inscription"
                    })
                );
            })
            .catch(handleRequestError);
        this.setState({ loading: false });

        return false
    };

    render() {
        const { intl, className } = this.props;

        return (
            <div className={clsx(className, "newsletter")}>
                <FormGroup>
                    <Label>
                        <FormattedMessage
                            id="portfolio.blog.newsletter.label"
                            defaultMessage="Inscrivez-vous à la newsletter"
                        />
                    </Label>
                    <Input
                        type="text"
                        className="input-field"
                        placeholder={
                            intl.formatMessage({
                                id: "portfolio.blog.newsletter.placeholder",
                                defaultMessage: "Entrez votre adresse email"
                            })
                        }
                        defaultValue={this.state.email}
                        onChange={(e) => this.setState({ email: e.target.value })}
                    />
                </FormGroup>
                <button className="btn btn-primary newsletter-subscribe-btn" onClick={this.submit}>
                    <FormattedMessage
                        id="portfolio.blog.newsletter.button"
                        defaultMessage="Je m'abonne"
                    />
                </button>
            </div>
        )
    }
}

export default injectIntl(NewsletterSubscription);
